import React, { useEffect, useState } from "react"
import { Button, FormGroup, Input } from "reactstrap"
import ym from "react-yandex-metrika"

import { GET_FORM_API } from "../utils/constants"
import success from "../images/success.svg"

const INITIAL_ERRORS_DATA = {
  problem: {
    message: "",
    fieldName: "",
    isErrored: false
  },
  phoneNumber: {
    message: "",
    fieldName: "",
    isErrored: false
  },
  emailAddress: {
    message: "",
    fieldName: "",
    isErrored: false
  }
}

const FormRequest = () => {
  const [validationErrors, setErrors] = useState(INITIAL_ERRORS_DATA)
  const [serverErrors, setServerErrors] = useState({
    isErrored: false,
    isSubmitting: false,
    message: ""
  })

  const [formData, setFormData] = useState({
    problem: "",
    phoneNumber: "",
    emailAddress: "",
    site: "",
    utm_source: "",
    utm_campaign: "",
    utm_medium: "",
    utm_content: "",
    utm_term: ""
  })

  const [successFormData, setSuccessFormData] = useState(false)

  function onChangeHandler(e) {
    setFormData({ ...formData, [e.target.name]: e.target.value })
    setErrors(INITIAL_ERRORS_DATA)
  }

  async function submitHandler(e) {
    e.preventDefault()
    try {
      const phoneNormalized = formData.phoneNumber.replace(/[^+\d]/g, "")

      const errorsCollection = {
        problem: {
          message: "",
          fieldName: "",
          isErrored: false
        },
        phoneNumber: {
          message: "",
          fieldName: "",
          isErrored: false
        },
        emailAddress: {
          message: "",
          fieldName: "",
          isErrored: false
        }
      }

      if (formData.problem.trim() === "") {
        errorsCollection.problem = {
          message: "Заполните обязательное поле",
          fieldName: "problem",
          isErrored: true
        }
      }

      if (
        formData.phoneNumber.trim() !== "" &&
        !/^\+[\d]{11}$/.test(phoneNormalized) &&
        !/^[\d]{11}$/.test(phoneNormalized)
      ) {
        errorsCollection.phoneNumber = {
          message: "Номер телефона должен состоять из 11 цифр",
          fieldName: "phoneNumber",
          isErrored: true
        }
      }

      if (
        formData.emailAddress.trim() === "" &&
        !/@/.test(formData.emailAddress.trim())
      ) {
        errorsCollection.emailAddress = {
          message: "Заполните обязательное поле",
          fieldName: "emailAddress",
          isErrored: true
        }
      }

      setErrors(errorsCollection)

      for (const value of Object.values(errorsCollection)) {
        if (value.isErrored) {
          return
        }
      }

      setServerErrors({
        isSubmitting: true
      })

      const response = await fetch(GET_FORM_API, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(formData)
      })

      if (response && response.ok && response.status === 200) {
        setFormData(prevState => ({
          ...prevState,
          problem: "",
          phoneNumber: "",
          emailAddress: ""
        }))

        setServerErrors({
          isSubmitting: false
        })
        setSuccessFormData(() => true)
      }
      ym("reachGoal", "form")
    } catch (e) {
      console.error(e)
      setServerErrors({
        isErrored: true,
        isSubmitting: false,
        message: "Что-то пошло не так, попробуйте снова"
      })
    }
  }

  function getQueryParams(qs) {
    qs = qs.split("+").join(" ")

    var params = {},
      tokens,
      re = /utm_[?&]?([^=]+)=([^&]*)/g
    while ((tokens = re.exec(qs))) {
      params[decodeURIComponent(tokens[1])] = decodeURIComponent(tokens[2])
    }
    return params
  }

  useEffect(() => {
    const timer = setTimeout(() => {
      setSuccessFormData(() => false)
    }, 4000)
    return () => {
      clearTimeout(timer)
    }
  }, [successFormData])

  useEffect(() => {
    if (typeof window !== "undefined") {
      let params = document.location.search || ""
      let utmObj = getQueryParams(params)

      console.log(utmObj)

      setFormData(prevState => ({
        ...prevState,
        site: window.location.host,
        utm_source: utmObj.source || "",
        utm_campaign: utmObj.campaign || "",
        utm_medium: utmObj.medium || "",
        utm_content: utmObj.content || "",
        utm_term: utmObj.term || ""
      }))
    }
  }, [])

  return (
    <div className="form_request card">
      {!successFormData ? (
        <form onSubmit={submitHandler}>
          <div className="form_title">
            Рассчитать бесплатно стоимость банкротства
          </div>
          <FormGroup>
            <Input
              type="text"
              className={validationErrors.problem.isErrored ? "invalid" : ""}
              placeholder="Описание проблемы"
              name="problem"
              value={formData.problem}
              onChange={onChangeHandler}
              autoComplete="off"
            />

            {validationErrors.problem.isErrored && (
              <span className="form_error">
                {validationErrors.problem.message}
              </span>
            )}
          </FormGroup>
          <FormGroup>
            <Input
              type="tel"
              name="phoneNumber"
              className={
                validationErrors.phoneNumber.isErrored ? "invalid" : ""
              }
              placeholder="Номер телефона"
              value={formData.phoneNumber}
              onChange={onChangeHandler}
              autoComplete="off"
            />

            {validationErrors.phoneNumber.isErrored && (
              <span className="form_error">
                {validationErrors.phoneNumber.message}
              </span>
            )}
          </FormGroup>
          <FormGroup>
            <Input
              type="email"
              className={
                validationErrors.emailAddress.isErrored ? "invalid" : ""
              }
              name="emailAddress"
              placeholder="Email"
              value={formData.emailAddress}
              onChange={onChangeHandler}
              autoComplete="off"
            />

            {validationErrors.emailAddress.isErrored && (
              <span className="form_error">
                {validationErrors.emailAddress.message}
              </span>
            )}
          </FormGroup>
          <div>
            <Input type="hidden" name="site" value={formData.site} readOnly />
            <Input
              type="hidden"
              name="utm_source"
              value={formData.utm_source}
              readOnly
            />
            <Input
              type="hidden"
              name="utm_campaign"
              value={formData.utm_campaign}
              readOnly
            />
            <Input
              type="hidden"
              name="utm_medium"
              value={formData.utm_medium}
              readOnly
            />
            <Input
              type="hidden"
              name="utm_content"
              value={formData.utm_content}
              readOnly
            />
            <Input
              type="hidden"
              name="utm_term"
              value={formData.utm_term}
              readOnly
            />
          </div>
          {serverErrors.isErrored && (
            <FormGroup>
              <span className="form_error">{serverErrors.message}</span>
            </FormGroup>
          )}
          <Button
            color="primary"
            block
            type="submit"
            disabled={serverErrors.isSubmitting}
          >
            {serverErrors.isSubmitting ? "Отправка..." : "Отправить запрос"}
          </Button>
        </form>
      ) : (
        <div className="form_success">
          <div className="form_success__icon">
            <img src={success} alt="Успешно" />
          </div>
          <div className="form_title">Ваш запрос принят</div>
          <p>
            В течении некоторого времени наши специалисты свяжутся с вами. Вам
            будет предоставлена цена на ваш объект имущества в соответствии с
            аналогами на рынке. Данный расчёт должен быть подтвержден
            профессиональными оценщиками в соответствии с требования
            действующего законодательства РФ.
          </p>
        </div>
      )}
    </div>
  )
}

export default FormRequest
